<!--公共底部-->
<template>
    <div>
        <el-row class="" type="flex" justify="center" :style="programaSetInfo?programaSetInfo.head_style:''">
            <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" >
                <!-- <router-link to="/MailHome" v-if="visitSource == 2"> -->
                <div style="display:inline-block;vertical-align: top;">
                    <img v-if="programaSetInfo && programaSetInfo.company_logo" :src="GLOBAL.getFileServeUrl()+programaSetInfo.company_logo" :style="programaSetInfo?programaSetInfo.logo_style:''" alt="logo_px">
                </div>
                <!-- </router-link> -->
                <div style="display:inline-block;vertical-align: top;" >
                    <div :style="programaSetInfo?programaSetInfo.name_style:''" class="aaa">{{loginTitle}}</div>
                    <div v-if="loginSecondTitle" :style="programaSetInfo?programaSetInfo.second_name_style:''">{{loginSecondTitle}}</div>
                </div>
            </el-col>
        </el-row>
        <el-row class="" type="flex" justify="center" style="height: 50px;background: linear-gradient(0deg, #EDEDED 0%, #FFFFFF 100%);">
            <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" style="display:flex;position: relative;">
                <el-menu class="zdy_header" :default-active="activeName"  mode="horizontal" :menu-trigger="visitSource == 2?'hover':'click'" @select="menuHandleClick" background-color="transparent" >
                    <template v-for="(item,index) in homeBarArr">
                        <el-menu-item :key="'homeTab_'+index" v-if="!item.childMenu || item.childMenu.length == 0" :index="index+''" >{{item.barName}}</el-menu-item>
                        <el-submenu :key="'homeTab_'+index" v-else :index="index+''" @click.native="menuHandleClick(index+'',[index])" popper-class="zdy_popper">
                        <template slot="title">{{item.barName}}</template>
                        <template v-for="(childItem,childIndex) in item.childMenu">
                            <el-menu-item :key="'homeTab_'+index+'_'+childIndex+''" :index="index+'_'+childIndex+''">{{childItem.barName}}</el-menu-item>
                        </template>
                        </el-submenu>
                    </template>
                </el-menu>
                <div v-if="visitSource == 2" style="position: absolute;margin-top: 8px;right:10px;">
                <!-- {{loginInfo}} -->
                <el-link v-if="loginInfo && loginInfo.USERID>0" target="_blank" style="margin: 0 5px 0 0;">{{loginInfo.USERNAME}}</el-link>
                <el-link v-if="loginInfo && loginInfo.USERID>0" target="_blank" @click="checkLoginOut">退出登录</el-link>
                <el-link v-else target="_blank" @click="checkLogin">登录</el-link>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import pageUtils from '@/js/page/pageUtil.js';
    import utils from '@/js/utils/util.js';
    export default {
        name: 'examinationHeader',
        props: {
            initHomeBarArr: {
                type: Array,
                value: null
            },
            initActiveName:{
                type:String,
                value:""
            }
        },
        data() {
            return {
                // 访问来源 PC:2 或者 H5:3
                visitSource:utils.checkVisitSource(),
                //项目表中的信息
                programaSetInfo:null,
                curriculumInfo:['退出登录'],
                // 登录人的信息
                loginInfo:{},
                activeName:"1",
                // 是否进行数据渲染
                hasLoad:false,
                //自定义标签页
                ind: 0,
                //nav搜索框
                inputSelect:'',
                //是否登陆
                whetherLogIn:false,
                homeBarArr:[],
                homeBarShowLength:0,
                loginTitle:"",
                loginSecondTitle:"",

            };
        },
        watch:{
            initHomeBarArr:function(newVal){
                var that = this;
                if(that.initHomeBarArr) {
                    that.initCreate();
                }
            }
        },
        created() {
            var that = this;
            that.initCreate();
        },
        mounted() {

        },
        methods: {
            initCreate(){
                var that = this;
                //判断客户端
                // let flag = utils.checkVisitSource(that);
                if(that.initActiveName && that.initActiveName != "") {
                    that.activeName = that.initActiveName;
                }

                // 获取PC电脑本次登录信息 用于单点登录或者页面设置信息的记录
                // utils.getShamLoginId(that);
                if(that.initHomeBarArr) {
                    that.homeBarArr = that.initHomeBarArr;
                    console.log("homeBarArr=========PC1=========",that.homeBarArr);
                } else {

                    //判断是否有后台的localStorage.homeMenuList
                    var homeMenuList = pageUtils.getHomeMenuList();
                    if(utils.isNotNull(homeMenuList)) {
                        that.homeBarArr = JSON.parse(homeMenuList);
                    }
        
                    console.log("homeBarArr=========PC2=========",that.homeBarArr);
        
                    // 登录人的信息
                    that.initLoginInfo();
                }
                var programaSetInfo = pageUtils.getSessionParam("programaSetInfo");
                if(programaSetInfo) {
                    this.programaSetInfo = JSON.parse(programaSetInfo);
                }
                if(localStorage.domain_name && localStorage.domain_name != "") {
                    that.loginTitle = this.programaSetInfo?this.programaSetInfo.programa_name:that.GLOBAL.loginProductName[localStorage.domain_name];
                    that.loginSecondTitle = this.programaSetInfo?this.programaSetInfo.programa_second_name:that.GLOBAL.loginSecondProductName[localStorage.domain_name];
                    
                } else {
                    that.loginTitle = that.GLOBAL.defaultProductName;;
                    that.loginSecondTitle = that.GLOBAL.defaultProductName;;
                }
                that.hasLoad = true;
            },
            /**
             * 刷新登录状态
             */
            initLoginInfo() {
                var that = this;
                if(utils.isNotNull(localStorage.loginInfo)) {
                    that.loginInfo = JSON.parse(localStorage.loginInfo);
                } else {
                    that.loginInfo = {};
                }
                var loginInfo = that.loginInfo;
                if(loginInfo) {
                    var userId = loginInfo.USERID;
                    if(userId>0){
                        that.whetherLogIn = true
                    } else {
                        that.whetherLogIn = false
                    }
                }
            },
//            点击搜索
            searchCheck(){
                var mainId = pageUtils.getShamOpenId();
                var toListJson = {
                    pageId: 23364,
                    tableId: 18073
                }
                //判断是否有 传递的默认搜索条件 如果有则进行穿度
                pageUtils.toNewListPage(this,toListJson);
            },
//            点击登录
            checkLogin(){
                var that = this
                var userId = -1;
                if(utils.isNotNull(localStorage.loginInfo)) {
                    that.loginInfo = JSON.parse(localStorage.loginInfo);
                }
                var loginInfo = that.loginInfo;
                if(loginInfo) {
                    userId = loginInfo.USERID;
                }
                if (!(userId>0)) {
                    // 打开弹窗登录页面 登录后继续进行触发
                    // 如果未登录 进行打开登录页面的操作
                    if(that.$router.app.$children[0].openLogin) {
                        that.$router.app.$children[0].openLogin();
                        // that.whetherLogIn = false
                    }
                    return;
                }else{
                    that.whetherLogIn = true
                }
            },
            /**
             * 右上角 学员姓名点击时触发
             */
            handleCommand(command){
                var that = this;
                // 暂时只保留退出登录按钮
                utils.loginOut(that);
            },
            tabHandleClick:function(tab, event){
                console.log("tab------------------",tab,event);
                var index = tab.index;
                var tabName = this.homeBarArr[index].barKey;
                if(this.$listeners['handleClick']){
                    this.$emit("handleClick",tabName,index)
                } else {
                    this.jumpToMailHome(tabName);
                }
            },
            menuHandleClick:function(index,indexPath){
                var that = this;
                console.log("menuHandleClick------------------",index,indexPath);
                if(this.$listeners['menuHandleClick']){
                    this.$emit("menuHandleClick",index,indexPath)
                } else {
                    this.jumpToMailHome(index);
                }
            },
            /**
             * 跳转到mailHome页面
             */
            jumpToMailHome: function(activeName){
                var that = this;
                var domain_name = "";
                if(localStorage.domain_name) {
                    domain_name = localStorage.domain_name;
                }
                that.$router.push({
                    path: 'mailHome'+(domain_name != ""?("/"+domain_name):""),
                    query: {initActiveName:activeName}
                })
            },
            checkLoginOut(){
                var that = this;
                // 暂时只保留退出登录按钮
                utils.loginOut(that);
            }

        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .active_menu_pc{border-bottom: 2px solid #F4312D}
    .nav_img{text-align: right}
    .active_menu{color: #f759ab}
    .input-with-search{border:1px solid #ddd;padding: 3px 0 3px 30px;border-radius: 30px;font-size: 12px;width: 220px;vertical-align: middle}
    .el-icon-search{position: absolute;left: 12px;top: 7px}
    .entrance_project{color: #000;display: inline-block;margin-left: 50px}
    .Sign_in{display: inline-block;margin-right: 10px;vertical-align: middle}
    .register_in{display: inline-block;margin-left: 10px;vertical-align: middle}
    .Vertical_line{width: 2px;background: #000;height: 12px;display: inline-block;border-radius: 2px;vertical-align: middle}
    .title_tab{color: #000000;font-size: 20px}
    .title_tab span{padding: 0 0 2px;display: inline-block;margin: 0 25px}
    .aaa::after{
        content: '';
        display: inline-block;
        background: #dce1e3;
        width: 1px;
        height: 10px;
        margin: 0 6px;
    }
</style>
<style>
    .zdy_header .el-submenu__title{
        height: 48px !important;
        line-height: 48px !important;
        font-size: 14px !important;
        font-family: PingFang SC !important;
        font-weight: 400 !important;
        color: #666666 !important;
    }
    .zdy_header .el-menu-item{
        height: 48px !important;
        line-height: 48px !important;
        font-size: 14px !important;
        font-family: PingFang SC !important;
        font-weight: 400 !important;
        color: #666666 !important;
    }
    .zdy_header .el-submenu::after{
        content: '';
        display: inline-block;
        background: linear-gradient(90deg, #9F7E60 50%, #D6BEA9 50%);;
        width: 2px;
        height: 14px;
        position: absolute;
        margin: 0 0 0 105px;
        top: 17px;
    }
    .zdy_header .el-menu-item::after{
        content: '';
        display: inline-block;
        background: linear-gradient(90deg, #9F7E60 50%, #D6BEA9 50%);;
        width: 2px;
        height: 14px;
        margin: 17px 5px 0 16px;
        position: absolute;
    }
    .zdy_header .el-submenu:last-child::after{
        display:none;
    }
    .zdy_popper{
        width: 100%;
        height: 30px;
        background: #9F7E60;
        text-align: center;
    }
    .zdy_popper .el-menu-item{
        display:inline-block;
        height: 14px !important;
        line-height: 14px !important;
        font-size: 14px !important;
        font-family: PingFang SC !important;
        font-weight: 400 !important;
        color: #FFFFFF !important;
    }
    .zdy_popper .el-menu-item::after{
        content: '/';
        margin: 0 0 0 21px;
    }
    .zdy_popper .el-menu-item:last-child::after{
        display:none;
    }
    .zdy_popper .el-menu--popup-bottom-start{
        margin-top: 0px !important;
    }

   
    
</style>
